var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isVerifying)?[(_vm.adminLoggedInfo)?_c('Header'):_vm._e(),_c('router-view'),(_vm.adminLoggedInfo)?_c('Footer'):_vm._e(),_c('Notification'),_c('Confirm'),_c('Loading')]:_vm._e(),_c('Verify')],2)}
var staticRenderFns = []

export { render, staticRenderFns }